/**
 * EnjoyModule — bundles the two existing /enjoy admin panels into one
 * module page with sub-tabs:
 *   · Overlays  (legacy EnjoyOverlaysPanel · event overlays CRUD)
 *   · Signature queue  (legacy SignatureQueuePanel · /enjoy Signature
 *     Experiences image queue + publish gate)
 *
 * Migrated from Editorial-desk tabs "Enjoy overlays" + "Signature queue".
 */
import React, { useState } from "react";
import EnjoyOverlaysPanel from "@/pages/admin/EnjoyOverlaysPanel";
import SignatureQueuePanel from "@/pages/admin/SignatureQueuePanel";
import LegacyHost from "@/pages/admin/os/LegacyHost";

const SUB_TABS = [
  { k: "overlays", l: "Overlays", legacy: "Enjoy overlays" },
  { k: "signature", l: "Signature queue", legacy: "Signature queue (/enjoy)" },
];

export default function EnjoyModule() {
  const [tab, setTab] = useState("overlays");
  const current = SUB_TABS.find((t) => t.k === tab) || SUB_TABS[0];
  return (
    <div data-testid="os-modules-enjoy">
      <div className="os-pagehead">
        <h1>Enjoy</h1>
        <span className="count">migrated from · {current.legacy}</span>
      </div>
      <div className="os-toolbar" data-testid="os-enjoy-subtabs">
        {SUB_TABS.map((t) => (
          <button
            key={t.k}
            className={`os-fchip ${tab === t.k ? "on" : ""}`}
            onClick={() => setTab(t.k)}
            data-testid={`os-enjoy-subtab-${t.k}`}
          >
            {t.l}
          </button>
        ))}
      </div>
      <div className="os-legacy-host">
        {tab === "overlays" && <EnjoyOverlaysPanel />}
        {tab === "signature" && <SignatureQueuePanel />}
      </div>
    </div>
  );
}
